import { render, staticRenderFns } from "./PassCard.vue?vue&type=template&id=4eb3eab8&scoped=true"
import script from "./PassCard.vue?vue&type=script&lang=js"
export * from "./PassCard.vue?vue&type=script&lang=js"
import style0 from "./PassCard.vue?vue&type=style&index=0&id=4eb3eab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3eab8",
  null
  
)

export default component.exports